/**
 * Container for Nav
 *
 * @module containers/NavContainer
 */

import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import * as Actions from '../../actions';
import Nav from '../../components/Nav/Nav';
import * as Constants from '../../constants';
import { AppBgKeys, BgThemes, NavThemes } from '../../constants/App';
import { ScrollKeys } from '../../constants/Scroll';
import { getInDomain } from '../../domains/externalUtils';
import {
  getBrowsePath,
  getCurrentPathnameFromState,
  getNowPlayingPath,
  isCurrentRouteOnDemandNowPlaying,
} from '../../lib/RouteUtils';
import {
  getAppBg,
  getCurrentDominantColor,
  getIsNowPlayingOpen,
  getIsSearchOpen,
  getNavContentTheme,
} from '../../lib/UIStateUtils';
import * as Selectors from '../../selectors';
import * as Utils from '../../utils';

class NavContainer extends React.Component {
  static propTypes = {
    shouldLoadFacebookSDKAndUpdateStatus: PropTypes.bool,
    loadFbSdkAndUpdateLoginStatus: PropTypes.func,
    productTierIsAdSupported: PropTypes.bool,
    productTierIsPlus: PropTypes.bool,
    signUpClicked: PropTypes.func,
    logInClicked: PropTypes.func,
  };

  componentDidMount() {}

  render() {
    return <Nav {...this.props} />;
  }
}

export function mapStateToProps(state) {
  const user = Utils.Listener.getCurrentListenerFromState(state);
  const listenerImgUrl = user ? Utils.Listener.getListenerImageUrl(user) : '';
  const isAnonymous = Utils.Listener.isAnonymousListener(state);
  const isScrolled = state.scroll.get(ScrollKeys.IS_SCROLLED);
  const activeAdSkinName = getInDomain('displayAds.utils.getActiveAdSkinName', null)(state);
  const isAdSkinClassAppliedToElement = getInDomain(
    'displayAds.utils.getIsAdSkinClassAppliedToElement',
    false,
  )(state, activeAdSkinName);
  const pathname = getCurrentPathnameFromState(state);
  const isRightRailActive =
    getInDomain('ads.utils.getIsRightRailActive', false)(state) ||
    getInDomain('ads.utils.getIsElementCenteredWithAds', false)(state);
  const showPremiumFeatures = Utils.Listener.hasPremiumFeatures(state);
  const currentMyCollectionPath = showPremiumFeatures
    ? getInDomain('collection.utils.getCurrentMyCollectionPath', null)(state)
    : null;
  const nowPlayingPath = getNowPlayingPath(state);
  const browsePath = getBrowsePath(state);
  const navPrimaryTheme = getNavContentTheme(state);
  const isNowPlayingOnDemandPath = isCurrentRouteOnDemandNowPlaying(state);
  const isAutoplay =
    Utils.SourceType.getPandoraTypeFromPandoraId(
      getInDomain('playback.selectors.getCurrentItemSourceId', null)(state),
    ) === Constants.SourceTypes.PandoraTypes.AUTOPLAY;
  const appBg = getAppBg(state);
  const displayBackgroundColor =
    appBg.get(AppBgKeys.BG_THEME) === BgThemes.IMG &&
    isScrolled &&
    (!isNowPlayingOnDemandPath || isAutoplay);
  const backgroundColor = displayBackgroundColor ? getCurrentDominantColor(state) : '';
  const isSearchOpen = getIsSearchOpen(state);
  const shouldLoadFacebookSDKAndUpdateStatus =
    !Utils.Listener.isAnonymousListener(state) && Utils.Listener.isConnectedToFacebook(state);
  const isSafari = Utils.ClientInfo.getBrowserInfo().name === 'Safari';
  const isCollectionEmpty = getInDomain('collection.utils.isCollectionEmpty', false)(state);
  const navSecondaryTheme =
    isSearchOpen ||
    (!getIsNowPlayingOpen(state) &&
      getInDomain('displayAds.utils.getIsDisplayAdAllowedOnPage', false)(state))
      ? NavThemes.LIGHT
      : navPrimaryTheme;
  const hasCurrentTrack = !isEmpty(
    getInDomain('playback.utils.getCurrentTrackFromActivePlaylist', null)(state),
  );

  return {
    nowPlayingPath,
    browsePath,
    pathname,
    backgroundColor,
    theme: appBg.get(AppBgKeys.NAV_THEME),
    branding: (user && user.get('branding')) || '',
    listenerImgUrl,
    isAnonymous,
    isScrolled,
    activeAdSkinName,
    isAdSkinClassAppliedToElement,
    isRightRailActive,
    showPremiumFeatures,
    currentMyCollectionPath,
    navPrimaryTheme,
    navSecondaryTheme,
    isNowPlayingOnDemandPath,
    isSearchOpen,
    productTierIsAdSupported: Selectors.Payments.productTierIsAdSupported(state),
    productTierIsPlus: Selectors.Payments.productTierIsPlus(state),
    shouldLoadFacebookSDKAndUpdateStatus,
    isSafari,
    isCollectionEmpty,
    hasCurrentTrack,
  };
}

export default connect(mapStateToProps, {
  openDropdown: Actions.Dropdown.openDropdown,
  loadFbSdkAndUpdateLoginStatus: Actions.Social.loadFbSdkAndUpdateLoginStatus,
  signUpClicked: Actions.Integrations.signUpClicked,
  logInClicked: Actions.Integrations.logInClicked,
})(NavContainer);
